/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { Constants } from '../../../Constants';
import { SecurityScheme } from '../../../models/common/SecurityScheme';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';
import { Oas20SecurityScheme } from '../../../../openapi/v2/models/Oas20SecurityScheme';
import { RequiredPropertyValidationRule } from './RequiredPropertyValidationRule';

/**
 * Constructor.
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends RequiredPropertyValidationRule
 * @author eric.wittmann@gmail.com
 */
export class OasMissingOAuthSchemeTokenUrlRule extends RequiredPropertyValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitSecurityScheme(io.apicurio.datamodels.core.models.common.SecurityScheme)
     * @param {SecurityScheme} node
     */
    public visitSecurityScheme(node : SecurityScheme) {
        if(this.equals(node.type, "oauth2")) {
            let scheme : Oas20SecurityScheme = <Oas20SecurityScheme>node;
            if((this.equals(scheme.flow, Constants.PROP_PASSWORD) || this.equals(scheme.flow, "application") || this.equals(scheme.flow, "accessCode")) && !this.isDefined(scheme.tokenUrl)) {
                this.report(scheme, Constants.PROP_TOKEN_URL, this.map.apply(this, ));
            }
        }
    }
}
OasMissingOAuthSchemeTokenUrlRule["__class"] = "io.apicurio.datamodels.core.validation.rules.required.OasMissingOAuthSchemeTokenUrlRule";
OasMissingOAuthSchemeTokenUrlRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




